import React from "react";
import PropTypes from "prop-types";

import Card from "../Card";
import ClientProfileField from "./ClientProfileField";
import { formatClientPhone } from "./clientProfileHelpers";

const ClientProfileDetailsCard = ({ client, labels }) => (
  <Card
    title={labels.details}
    classNames={{
      root: "client-portal-profile-page__details-card",
      body: "company-portal-profile-card__body",
    }}
  >
    <div className="company-portal-profile-field-grid company-portal-profile-field-grid--cols-3">
      <ClientProfileField
        label={labels.listClients.name}
        value={client?.name}
      />
      <ClientProfileField label={labels.email} value={client?.email} />
      <ClientProfileField
        label={labels.mobileNumber}
        value={formatClientPhone(client)}
        valueClassName="company-portal-profile-field__value--phone"
      />
    </div>
  </Card>
);

ClientProfileDetailsCard.propTypes = {
  client: PropTypes.object,
  labels: PropTypes.shape({
    details: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    mobileNumber: PropTypes.string.isRequired,
    listClients: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

ClientProfileDetailsCard.defaultProps = {
  client: null,
};

export default ClientProfileDetailsCard;
